import Link from 'next/link';

export default function LeadingLinks(props) {

    const { className, href, children, next, prev } = props;

    const leftArrow = (
        <span className="block rotate-180 mr-5 text-cc">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.8 11.59" height="10">
                <path d="M1,1,5.8,5.8,1,10.59" style={{fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2px"}}/>
            </svg>
        </span>
    );
    const rightArrow = (
        <span className="block ml-5 text-cc">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.8 11.59" height="10">
                <path d="M1,1,5.8,5.8,1,10.59" style={{fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2px"}}/>
            </svg>
        </span>
    );

    return (
        <Link
            href={ href ?? '#' }
            className={ "group inline-flex items-center text-cc no-underline transition-all hover:underline" + ( className ? " " + className : "" ) }
            passHref
        >
            { prev ? leftArrow : '' }
            <span>{ children }</span>
            { next ? rightArrow : '' }
        </Link>
    )
}